import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { botName, webAppName } from '../../../../../utils/common/botInfo';

export const ShopPublicRedirectContainer = () => {
    const { id } = useParams();
    useEffect(() => {
        window.location.href = `https://t.me/${botName}/${webAppName()}?startapp=${id}`;
    }, []);

    return <></>;
};
